import UpdateTicker from './components/UpdateTicker';
import NavBar from './components/NavBar';
import EntryBoard from './components/EntryBoard';
import FreshList from './components/FreshList';
import HeatRanking from './components/HeatRanking';
import TopicGrid from './components/TopicGrid';
import PendingAlert from './components/PendingAlert';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen w-full bg-background-50">
      <UpdateTicker />
      <NavBar />
      <EntryBoard />
      <FreshList />
      <HeatRanking />
      <TopicGrid />
      <PendingAlert />
      <Footer />
    </main>
  );
}